import { Stack } from 'expo-router';
import { Platform } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import Reservations from '@/components/reservations';
import { isDesktop } from '@/core';

export default function ReservationsScreen() {
  const { theme } = useStyles();
  return (
    <>
      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          options={{
            headerTitle: 'Reservations',
            headerLeft: () => null,
            headerBackVisible: false,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          }}
        />
      )}

      <Reservations />
    </>
  );
}
